import { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import type { MutableRefObject } from 'react'

/**
 * Přijímá ref na boolean isDirty.
 * useBlocker dostane getter funkci — vyhodnotí se až v okamžiku navigace,
 * takže vidí aktuální hodnotu ref i bez re-renderu.
 *
 * Volající musí:
 *   isDirtyRef.current = JSON.stringify(form) !== JSON.stringify(savedFormRef.current)
 * a před programatickou navigací (onSuccess) nastavit:
 *   isDirtyRef.current = false
 */
export function useUnsavedChanges(isDirtyRef: MutableRefObject<boolean>) {
  const blocker = useBlocker(() => isDirtyRef.current)

  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (isDirtyRef.current) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [isDirtyRef])

  return blocker
}
